<template>
    <div class="b-switcher">
        <div class="b-switcher__nav">
            <div v-if="!isMobile && nav.length" class="b-switcher__nav-container">
                <div
                    class="b-switcher__roller"
                    :style="{
                    transform: `translateX(${rollerLeft}px)`,
                    width: `${rollerWidth}px`
                }"
                ></div>
                <button
                    v-for="(item, idx) in nav"
                    :key="`b-sw-${idx}`"
                    @click.prevent="setCurSlot(idx)"
                    :ref="item.slot"
                    :class="{'_active': curSlotName === item.slot}"
                    :disabled="curSlotName === item.slot"
                    class="b-switcher__button g-text__p _semibold"
                >{{ item.title }}</button>
            </div>
            <div v-else class="b-switcher__dropdown u-btn-dropdown-parent js-dropdown-button _last">
                <button class="u-btn u-btn-dropdown _dark _m-full js-dropdown-switcher">
                    <span class="u-btn-dropdown__text">{{ curSlotTitle }}</span>
                    <svg class="u-btn__icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 14L5 8L15 8L10 14Z" fill="white"/>
                    </svg>
                </button>
                <div class="u-btn-dropdown__content js-dropdown-content">
                    <a
                        v-for="(item, idx) in nav"
                        :key="`b-sw-${idx}`"
                        @click.prevent="setCurSlot(idx)"
                        :ref="item.slot"
                        class="u-btn-dropdown__item"
                    >{{ item.title }}</a>
                </div>
            </div>
        </div>
        <div class="b-switcher__content">
            <slot :name="curSlotName"></slot>
        </div>
    </div>
</template>

<script>
    import dropdownButton from '../../pages/ui/button-dropdown';

    /*
     * в слотах данного комопнента должны находиться только контентные части переключателей
     * слоты именуются в соответствии с пропсом nav
     * */
    export default {
        props: {
            /*
             * передаём массив элементов навигации, внутри свойства:
             * slot - имя слота, который соотвествует данному элементу навигации
             * title - заголовок слота
             * */
            nav: {
                type: Array,
                default () {
                    return [];
                }
            },
            // передаём навзвание слота, элемент навигации которого будет активен
            curSlot: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                curSlotName: '',
                rollerLeft: 0,
                rollerWidth: 0,
                navInfo: [],
                isMobile: window.innerWidth < 768
            };
        },
        mounted() {
            this.setCurSlot(0, true);
            this.setNavInfo();

            if (this.isMobile) {
                dropdownButton();
            }
        },
        computed: {
            curSlotTitle () {
                return this.nav.find(item => item.slot === this.curSlotName)?.title;
            }
        },
        methods: {
            setCurSlot(idx, isFirstStart=false) {
                if (this.curSlot && this.$slots[this.curSlot] && isFirstStart) {
                    this.curSlotName = this.curSlot;
                } else {
                    this.curSlotName = Object.keys(this.$slots)[idx];
                }

                if (!isFirstStart) {
                    this.setRollerData(idx);
                }
            },
            setNavInfo() {
                let curSlotIdx = 0;

                Object.keys(this.$refs).forEach((item, idx) => {
                    if (this.curSlotName === item) {
                        curSlotIdx = idx;
                    }

                    this.navInfo.push({
                        width: this.$refs[item][0].offsetWidth,
                        left: this.$refs[item][0].offsetLeft
                    });
                });

                this.setRollerData(curSlotIdx);
            },
            setRollerData(idx) {
                if (this.isMobile) return;

                this.rollerLeft = this.navInfo[idx].left;
                this.rollerWidth = this.navInfo[idx].width;
            }
        }
    }
</script>
